import {GetFilteredRestResource, GetRestResource} from "../../api/RestResourceClient";

//API METHODS
export async function GetSeries(seriesId) {
    return await GetFilteredRestResource('api/series/' + seriesId, null, null, false, false, false, true);
}

export async function GetRecentlyPublishedEpisodes(seriesId) {
    return await GetRestResource('api/episodes/search/recently-published-by-series-id?seriesId=' + seriesId, false, true);
}

export async function GetSeriesByClusterId(clusterId) {
    let filter = {
        contentClusterId : clusterId
    }
    return await GetFilteredRestResource('api/series', filter, null, true, false, false, true);
}

//the age filter is given by ageMin and ageMax of the filter; the backend expects the range of the
//recommended age as repeated parameter (ageRecommended=<min>&ageRecommended=<max>)
const SERIES_AGE_RECOMMENDED_MAX = 99;

export async function GetAllSeries(filter) {
    const {ageMin, ageMax, ...seriesFilter} = filter;
    let url = 'api/series';
    const hasAgeMin = ageMin !== "" && ageMin != null;
    const hasAgeMax = ageMax !== "" && ageMax != null;
    if (hasAgeMin || hasAgeMax) {
        url += '?ageRecommended=' + (hasAgeMin ? ageMin : 0)
                + '&ageRecommended=' + (hasAgeMax ? ageMax : SERIES_AGE_RECOMMENDED_MAX);
    }
    return await GetFilteredRestResource(url, seriesFilter, null, true, false, false, true);
}

export function getEpisodeLength(episode) {
    if (episode.length && episode.length > -1) {
        const seconds = episode.length
        const minutes = Math.floor(seconds / 60);

        return '<span>' + minutes + "</span> Min";
    } else {
        return null;
    }
}

